/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Share_No_PlanInputs */

const en_us2_plan_share_no_plan = /** @type {(inputs: Plan_Share_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no plan in effect to share yet.`)
};

const pt_br2_plan_share_no_plan = /** @type {(inputs: Plan_Share_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há um plano em vigor para compartilhar.`)
};

const pt_pt2_plan_share_no_plan = /** @type {(inputs: Plan_Share_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há um plano em vigor para compartilhar.`)
};

/** @type {(inputs: Plan_Share_No_PlanInputs) => LocalizedString} */
const es_419_plan_share_no_plan = en_us2_plan_share_no_plan;

/** @type {(inputs: Plan_Share_No_PlanInputs) => LocalizedString} */
const fr_fr2_plan_share_no_plan = en_us2_plan_share_no_plan;

/** @type {(inputs: Plan_Share_No_PlanInputs) => LocalizedString} */
const de_de2_plan_share_no_plan = en_us2_plan_share_no_plan;

/** @type {(inputs: Plan_Share_No_PlanInputs) => LocalizedString} */
const it_it2_plan_share_no_plan = en_us2_plan_share_no_plan;

/**
* | output |
* | --- |
* | "There is no plan in effect to share yet." |
*
* @param {Plan_Share_No_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_share_no_plan = /** @type {((inputs?: Plan_Share_No_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Share_No_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_share_no_plan(inputs)
	if (locale === "es-419") return es_419_plan_share_no_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_share_no_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_share_no_plan(inputs)
	if (locale === "de-DE") return de_de2_plan_share_no_plan(inputs)
	if (locale === "it-IT") return it_it2_plan_share_no_plan(inputs)
	return en_us2_plan_share_no_plan(inputs)
});
export { plan_share_no_plan as "plan_share.no_plan" }